/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { ReservationApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const reservationApi = {
  show: wrap(ReservationApi, ReservationApi.prototype.getReservationDetail),
  showContact: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationContact,
  ),
  showService: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationService,
  ),
  showCalender: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationCalendarDetail,
  ),
  showServiceCalender: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationCalendarService,
  ),
  getReservationCalendar: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationCalendar,
  ),
  postCancel: wrap(
    ReservationApi,
    ReservationApi.prototype.postCancelReservation,
  ),
  putDates: wrap(ReservationApi, ReservationApi.prototype.putReservationDates),
  putReservationOrder: wrap(
    ReservationApi,
    ReservationApi.prototype.putReservationOrder,
  ),
  putReservationCalendarOrder: wrap(
    ReservationApi,
    ReservationApi.prototype.putReservationCalendarOrder,
  ),
  postReservationPayment: wrap(
    ReservationApi,
    ReservationApi.prototype.postReservationPayment,
  ),
  postReservationCalendarPayment: wrap(
    ReservationApi,
    ReservationApi.prototype.postReservationCalendarPayment,
  ),
  putReservationPrepareOrderViaPayPal: wrap(
    ReservationApi,
    ReservationApi.prototype.putReservationPrepareOrderViaPaypal
  ),
  getReservationCalendarNearestDate: wrap(
    ReservationApi,
    ReservationApi.prototype.getReservationCalendarNearestDate
  ),
  invalidateReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.invalidateReservation
  ),
};

export default reservationApi;
